module.exports = __webpack_public_path__ + "img/appAsset-brand--bsale.ecf8b6e1.svg";